import { LocaleCode, LOCALE_OPTIONS } from '@choco-admin/types';
import React from 'react';

import { ChocoSelect } from '../ChocoSelect';

export interface LocaleSelectFieldProps {
  value?: LocaleCode;
  onChange: (locale: LocaleCode) => void;
  isDisabled?: boolean;
  isRequired?: boolean;
  label?: string;
  placeholder?: string;
  errorMessage?: string;
  helperText?: string;
  'data-testid'?: string;
}

export const LocaleSelectField: React.FC<LocaleSelectFieldProps> = ({
  value,
  onChange,
  isDisabled = false,
  isRequired = false,
  label = 'Language',
  placeholder = 'Choose language...',
  errorMessage,
  helperText,
  'data-testid': dataTestId,
}) => {
  // Convert LOCALE_OPTIONS to ChocoSelect format
  const selectOptions = LOCALE_OPTIONS.map(
    (option: { key: LocaleCode; label: string }) => ({
      value: option.key,
      label: option.label,
    })
  );

  return (
    <div data-testid={dataTestId}>
      <ChocoSelect
        label={label}
        placeholder={placeholder}
        options={selectOptions}
        value={value || ''}
        onSelectionChange={(selectedValue) => {
          if (selectedValue && selectedValue in LocaleCode) {
            onChange(selectedValue as LocaleCode);
          }
        }}
        isDisabled={isDisabled}
        isRequired={isRequired}
        errorMessage={errorMessage}
        description={helperText}
        showDescriptions={false}
      />
    </div>
  );
};
